export default "__VITE_PUBLIC_ASSET__035078d1__"